// client/src/components/Auth/Unauthorized.js
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { LockOutlined, Home, ExitToApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import styles from "./Unauthorized.module.css";

function Unauthorized() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleGoHome = () => {
    navigate('/'); // Esto activará SmartRedirect
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <Box className={styles.container}>
      <Paper elevation={8} className={styles.paper}>
        <Box className={styles.iconContainer}>
          <LockOutlined className={styles.icon} />
        </Box>

        <Typography variant="h4" className={styles.title}>
          Acceso Denegado
        </Typography>

        <Typography variant="body1" className={styles.message}>
          No tienes los permisos necesarios para acceder a esta página.
        </Typography>

        {user && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 3 }}>
            Usuario: {user.nombre} ({user.rol})
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={handleGoHome}
            className={styles.button}
          >
            Ir al Inicio
          </Button>
          
          <Button
            variant="outlined"
            startIcon={<ExitToApp />}
            onClick={handleLogout}
            color="secondary"
          >
            Cerrar Sesión
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default Unauthorized;
